import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Don't be weird",
  "description": "",
  "published": "2020-05-08T00:00:00.000Z",
  "redirect_from": ["/blog/dont-be-weird/swizec/9411"],
  "categories": "Technical",
  "hero": "./img/techletter.app-screenshot-1588990757609.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A little weird is fine.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1258829089168736256"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "137.21973094170403%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'549\\'%20viewBox=\\'0%200%20400%20549\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2017c-10%205-11%2018-1%2025%204%202%2011%203%2015%200%204-1%204-3%201-4-4-1-3-5%201-5%205-1%206-5%203-10%200-2-1-3-2-3l-3-2c-3-3-9-4-14-1m-7%2046l1%206c2%201%206-1%207-3l1-2%201%202c1%204%206%203%206-2-1-3-4-4-6-1-1%201-1%201-2-1-1-3-2-3-4-3-4%200-4%200-4%204\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fbd298d0e74e894c71ad6af6e6e66419/ca0a1/techletter.app-screenshot-1588990757609.webp 223w", "/static/fbd298d0e74e894c71ad6af6e6e66419/75680/techletter.app-screenshot-1588990757609.webp 445w", "/static/fbd298d0e74e894c71ad6af6e6e66419/0ba47/techletter.app-screenshot-1588990757609.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fbd298d0e74e894c71ad6af6e6e66419/e92b6/techletter.app-screenshot-1588990757609.png 223w", "/static/fbd298d0e74e894c71ad6af6e6e66419/e66bf/techletter.app-screenshot-1588990757609.png 445w", "/static/fbd298d0e74e894c71ad6af6e6e66419/6af66/techletter.app-screenshot-1588990757609.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/fbd298d0e74e894c71ad6af6e6e66419/6af66/techletter.app-screenshot-1588990757609.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`But progress happens thanks to people who are weird.`}</p>
    <p>{`Here's a rule a thumb I like to use when choosing technologies:`}</p>
    <p>{`Experiment? 👉 be as weird as possible.`}</p>
    <p>{`For production? 👉 be as boring as possible.`}</p>
    <p>{`You see my friend having fun brings with it a lot of responsibility. Who will maintain this code? You will.`}</p>
    <p>{`Who else will maintain this code? You will.`}</p>
    <p>{`Wanna get promoted? Wanna move to a different project? Wanna do anything else with your life than maintain code even you barely understand?`}</p>
    <p>{`Sure!`}</p>
    <p>{`How long will it take to train a replacement? How much documentation did you write? Can you even find someone who wants to learn this bespoke magic they'll never get to use again in any other job?`}</p>
    <p>{`Until you figure that out, you're stuck.`}</p>
    <p>{`So don't be weird. Nudge at the edges. Don't jump too far too fast.`}</p>
    <p>{`❤️`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>
    <p>{`PS: looks like the economy has mostly recovered (according to stock charts) from the panic drop in late March so think I'm gonna remove the `}<a parentName="p" {...{
        "href": "https://serverlessreact.dev"
      }}>{`37% discount on ServerlessReact.Dev`}</a>{` on Monday. If you're thinking about building modern webapps front-to-back, now's a great time to get a copy :)`}</p>
    <p>{`PPS: do video courses have copies? 🤔`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      